import ENewsLettersBlock from './ENewsLettersBlock';

export default ENewsLettersBlock;
